var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrowLight = function SvgArrowLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.927,
    height: 12.239,
    viewBox: "0 0 6.927 12.239"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "arrow_2_",
    d: "M6.927,11.431l-.808.808L0,6.119,6.119,0l.808.808L1.616,6.119l5.311,5.311Z",
    transform: "translate(6.927 12.239) rotate(180)",
    fill: "#ffebc3",
    fillRule: "evenodd"
  })));
};

export { SvgArrowLight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2LjkyNyIgaGVpZ2h0PSIxMi4yMzkiIHZpZXdCb3g9IjAgMCA2LjkyNyAxMi4yMzkiPgogIDxwYXRoIGlkPSJhcnJvd18yXyIgZD0iTTYuOTI3LDExLjQzMWwtLjgwOC44MDhMMCw2LjExOSw2LjExOSwwbC44MDguODA4TDEuNjE2LDYuMTE5bDUuMzExLDUuMzExWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNi45MjcgMTIuMjM5KSByb3RhdGUoMTgwKSIgZmlsbD0iI2ZmZWJjMyIgZmlsbC1ydWxlPSJldmVub2RkIi8+Cjwvc3ZnPgo=";